module.exports = __webpack_public_path__ + "GnuMICR.9c26b8a97d279411e4de.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/fonts/GnuMICR.svg
// module id = ../../../../../src/fonts/GnuMICR.svg
// module chunks = styles